import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[hypo-autofocus]',
})
export class AutofocusDirective implements AfterViewInit {
    private readonly host = inject(ElementRef);

    ngAfterViewInit() {
        setTimeout(() => {
            this.host.nativeElement.focus();
        }, 200);
    }
}
